export interface State {
  notices: []
  isNoticeLoading: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  notices: [],
  isNoticeLoading: false
}

export const mutations: Mutations = {
  setNotices(state, payload) {
    state.notices = payload.notices
  },
  clearNotices(state) {
    state.notices = []
  },
  onNoticesLoadingStart(state) {
    state.isNoticeLoading = true
  },
  onNoticesLoadingFinished(state) {
    state.isNoticeLoading = false
  }
}

export const actions: Actions = {
  async fetchNotices({ commit }, payload) {
    commit('clearNotices', {})
    commit('onNoticesLoadingStart', {})
    const { response, error } = await this.$api.fetchNotices(payload)
    if (response) {
      commit('setNotices', response)
      await this.$delay(500)
      commit('onNoticesLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onNoticesLoadingFinished', {})
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
